import React, { useEffect, useState } from "react";
import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";

// The North Star (Victor, 2026-08-22): habit-activated users — completed
// activities on >= 3 distinct days. Headline = lifetime cumulative (only
// goes up); the rolling 7/28-day counts are the operating pulse and may
// fall. The bar strip is newly-activated per ISO week.
export default function NorthStarCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await AxiosInstance.get(ApiList.ADMIN_NORTHSTAR);
        if (res?.data?.s === 1) setData(res.data.r);
      } catch (e) {
        /* dashboard must render without it */
      }
    })();
  }, []);

  if (!data) return null;
  const weeks = data.weekly_newly_activated || [];
  const max = Math.max(1, ...weeks.map((w) => w.newly_activated));
  const habitWeeks = data.weekly_in_habit || [];
  const habitMax = Math.max(1, ...habitWeeks.map((w) => w.in_habit));

  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        p: 2,
        mb: 2,
        background: "#fffdf4",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <StarIcon sx={{ color: "#e0a900" }} />
        <Typography fontWeight={700}>North Star — habit-activated</Typography>
        <Typography variant="caption" color="text.secondary">
          {data.definition}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={4} alignItems="flex-end" flexWrap="wrap" useFlexGap>
        <Box>
          <Typography variant="h3" fontWeight={800} lineHeight={1}>
            {data.lifetime_activated}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            lifetime (cumulative)
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Chip size="small" label={`${data.in_habit_7d} in habit · 7d`} />
          <Chip size="small" label={`${data.in_habit_28d} in habit · 28d`} />
        </Stack>
        <Box sx={{ flex: 1, minWidth: 220 }}>
          <Stack direction="row" spacing={0.5} alignItems="flex-end" sx={{ height: 44 }}>
            {weeks.map((w) => (
              <Tooltip
                key={w.yw}
                title={`wk ${String(w.yw).slice(4)} — ${w.newly_activated} newly activated`}
              >
                <Box
                  sx={{
                    flex: 1,
                    height: `${Math.max(8, (w.newly_activated / max) * 100)}%`,
                    background: "#b9cc03",
                    borderRadius: "3px 3px 0 0",
                  }}
                />
              </Tooltip>
            ))}
          </Stack>
          <Typography variant="caption" color="text.secondary">
            newly activated per week (last {weeks.length})
          </Typography>
        </Box>
        <Box sx={{ flex: 1, minWidth: 220 }}>
          <Stack direction="row" spacing={0.5} alignItems="flex-end" sx={{ height: 44 }}>
            {habitWeeks.map((w) => (
              <Tooltip
                key={w.yw}
                title={`wk ${String(w.yw).slice(4)} — ${w.in_habit} in habit`}
              >
                <Box
                  sx={{
                    flex: 1,
                    height: `${Math.max(8, (w.in_habit / habitMax) * 100)}%`,
                    background: "#e0a900",
                    borderRadius: "3px 3px 0 0",
                  }}
                />
              </Tooltip>
            ))}
          </Stack>
          <Typography variant="caption" color="text.secondary">
            in habit per week (3+ active days that week)
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
